
import { DocumentiActions } from './DocumentiActions';
import update from 'immutability-helper';

const initialState = {
    showConfirmPublicDoc :false,
    tabSelected: 'doc-tab',
    dataSourceTabSel: 'dataSource-tab',
    listaDoc: [],
    documento: {},
    idDocumentoOrigine : null,
    showConfermaNuovaVersione: false,
    versioniDoc: [],
    idUltimaVersioneDoc: null,
    toggleNuovoDoc: false,
    nuovoDoc: {},
    isAlreadyExistingDoc: false,
    isInEditMode: false,
    validationDoc: new Map(),
    history: {},
    //dataSource
    listaDataSource: null,
    dataSource: {
        listParam: []
    },
    modificaDSstat: false,
    parametersMap: new Map(),
    listaPreview: [],
    statistiche: {},
    dsPreviewParams: new Map(),
    utilities: {
        listDocPdf:[]
    }
}

const documentiReducer = (state, action) => {

    if (typeof state === 'undefined') {
        return initialState
    }


    switch (action.type) {

        case DocumentiActions.DOCUMENTI_UPDATE:
            return update(state, action.documenti);

        case DocumentiActions.DOCUMENTI_LIST:
            return update(state, { listaDoc: { $set: action.result } });

        case DocumentiActions.DOCUMENTO_VERSIONE:
            return update(state, { versioniDoc: { $set: action.result } });

        case DocumentiActions.ID_ULTIMA_VERSIONE:
            return update(state, { idUltimaVersioneDoc: {$set: action.result} })

        case DocumentiActions.HANDLE_NUOVO_DOC_POPUP:
            return update(state, { toggleNuovoDoc: { $set: action.result } });

        case DocumentiActions.LOAD_DOCUMENTO:
            return update(state, {documento: {$set: action.result}});

        case DocumentiActions.HANDLE_CHANGE_DOC:
        case DocumentiActions.REMOVE_FILE:
            return update(state, { nuovoDoc: { $set: { ...action.result } } });

        case DocumentiActions.HANDLE_CHANGE_DS:
            return update(state, { dataSource: { $set: action.result } });

        case DocumentiActions.IS_ALREADY_EXISTING_DOC:
            return update(state, { isAlreadyExistingDoc: { $set: action.result } });

        case DocumentiActions.DOCUMENTO_UPDATE:
            return update(state, action.documento);

        case DocumentiActions.SET_IS_IN_EDIT_MODE:
            return update(state, { isInEditMode: { $set: action.result } });
        //Data Source

        case DocumentiActions.DATA_SOURCE_LIST:
            return update(state, { listaDataSource: { $set: action.result } });

        case DocumentiActions.GET_DS:
            return update(state, { dataSource: { $set: action.result } });

        case DocumentiActions.TOGGLE_MODIFICA:
            return update(state, { modificaDSstat: { $set: action.result } });

        case DocumentiActions.TOGGLE_MOSTRA_POPUP_CONFERMA_NUOVA_VERSIONE:
            return update(state, { showConfermaNuovaVersione: {$set: action.showConfermaNuovaVersione} });
        
        case DocumentiActions.PUBLISH_DOCUMENT:
            let doc = Object.assign({}, state.documento);
            doc.pubblicato = action.publishStatus;
            return update(state, { documento: {$set: doc} });

        case DocumentiActions.ID_DOCUMENTO_ORIGINE:
            return update(state, { idDocumentoOrigine: {$set: action.idDocumentoOrigine} });
        case DocumentiActions.SHOW_CONFIRM_PUBLIC_DOC:
            return update(state, { showConfirmPublicDoc: {$set: action.showConfirmPublicDoc} });
        default:
            return state;
    }
}

export default documentiReducer;